import React, { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import LightTooltip from "../LightTooltip";
import { Tooltippy } from "../../actions/Tippy";

import { ReactComponent as WHATSAPPICON } from "../../build/new-midias-icons/whatsapp.svg";
import { ReactComponent as FACEBOOKICON } from "../../build/new-midias-icons/facebook.svg";
import { ReactComponent as INSTAGRAM } from "../../build/new-midias-icons/instagram.svg";
import { ReactComponent as VOZICON } from "../../build/new-midias-icons/voz.svg";
import { ReactComponent as EMAILICON } from "../../build/new-midias-icons/email.svg";
import { ReactComponent as TELEGRAMICON } from "../../build/new-midias-icons/telegram.svg";
import { ReactComponent as TWITTERICON } from "../../build/new-midias-icons/twitter.svg";
import { ReactComponent as LINKEDINICON } from "../../build/new-midias-icons/linkedin.svg";
import { ReactComponent as WEBCHATICON } from "../../build/new-midias-icons/webchat.svg";
import { ReactComponent as SMSICON } from "../../build/new-midias-icons/sms-icon.svg";
import { ReactComponent as TEAMSICON } from "../../build/new-midias-icons/teams.svg";

import { ReactComponent as VOZICONLIST } from "../../build/images/channels/voz-icon.svg";
import { ReactComponent as FACEBOOKICONLIST } from "../../build/images/channels/facebook.svg";
import { ReactComponent as WHATSAPPICONLIST } from "../../build/images/channels/whatsapp.svg";
import { ReactComponent as EMAILICONLIST } from "../../build/images/channels/email.svg";
import { ReactComponent as INSTAGRAMICONLIST } from "../../build/images/channels/instagram.svg";
import { ReactComponent as TELEGRAMICONLIST } from "../../build/images/channels/telegram.svg";

import "./select-route-active-call.styles.css";
import OptionsDropDown from "./Components/OptionsDropDown";
import { connection_platform } from "../../services/api";
import { useSelectRouteActiveCall } from "./hooks/useSelectRouteActiveCall";
// import { ArrowDown2 } from "iconsax-reactjs";
import { ReactComponent as ArrowDown2 } from "../../build/images/new-active-call/arrow_drop_down.svg";

const SelectRouteActiveCall = ({
  midiaId,
  onChooseRoute = () => {},
  numeroDoCliente = "",
  type = "icones",
  size = "regular",
}) => {
  const { routeOptions, PermissionRouter, numberOfRoutes, open, setOpen } =
    useSelectRouteActiveCall(midiaId, numeroDoCliente);

  const renderCorrectIcon = {
    1: <VOZICON />,
    2: <WEBCHATICON />,
    3: <EMAILICON />,
    4: <FACEBOOKICON />,
    5: <WHATSAPPICON />,
    6: <INSTAGRAM />,
    8: <TELEGRAMICON />,
    9: <TWITTERICON />,
    10: <LINKEDINICON />,
    12: <SMSICON />,
    15: <TEAMSICON />,
  };

  const renderCorrectMidiaName = {
    1: "Voz",
    2: "Webchat",
    3: "Email",
    4: "Facebook",
    5: "WhatsApp",
    6: "Instagram",
    8: "Telegram",
    9: "Twitter",
    10: "LinkedIn",
    12: "SMS",
    15: "Teams",
  };

  const renderCorrecListElement = {
    1: (
      <a href="#" className="context-menu__link">
        <VOZICON />
        <Tooltippy content={numeroDoCliente}>
          <span
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              color: "#757575",
            }}
          >
            {numeroDoCliente}
          </span>
        </Tooltippy>
      </a>
    ),
    5: (
      <a href="#" className="context-menu__link">
        <WHATSAPPICONLIST />
        <Tooltippy content={numeroDoCliente}>
          <span
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              color: "#757575",
            }}
          >
            {numeroDoCliente}
          </span>
        </Tooltippy>
      </a>
    ),
    4: (
      <a href="#" className="context-menu__link">
        <FACEBOOKICON />
        <Tooltippy content={numeroDoCliente}>
          <span
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              color: "#757575",
            }}
          >
            {numeroDoCliente}
          </span>
        </Tooltippy>
      </a>
    ),
    3: (
      <a href="#" className="context-menu__link">
        <EMAILICON />
        <Tooltippy content={numeroDoCliente}>
          <span
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              color: "#757575",
            }}
          >
            {numeroDoCliente}
          </span>
        </Tooltippy>
      </a>
    ),
    8: (
      <a href="#" className="context-menu__link">
        <TELEGRAMICON />
        <Tooltippy content={numeroDoCliente}>
          <span
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              color: "#757575",
            }}
          >
            {numeroDoCliente}
          </span>
        </Tooltippy>
      </a>
    ),
    6: (
      <a href="#" className="context-menu__link">
        <INSTAGRAM />
        <Tooltippy content={numeroDoCliente}>
          <span
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.25px",
              color: "#757575",
            }}
          >
            {numeroDoCliente}
          </span>
        </Tooltippy>
      </a>
    ),
    9: <></>,
    10: <></>,
    2: <></>,
    12: <></>,
  };

  const sizeOfSvg = {
    small: "8",
    regular: "12",
  };

  const sizeOfNumberRoutes = {
    small: "8px",
    regular: "11px",
  };
  const sizeOfButton = {
    small: "22.5px",
    regular: "100%",
  };

  const paddingOfContainer = {
    small: "0px",
    regular: "0px",
  };

  const heightOfContainer = {
    small: "37px",
    regular: "41px",
  };
  const paddingOfButton = {
    small: "2px",
    regular: "4px",
  };

  return (
    <div
      className={`select-route-active-call-midia ${
        type === "list" ? "list-type" : ""
      } ${open ? "opened" : ""} ${
        numberOfRoutes > 1 ? "more-of-one-routes" : ""
      }`}
      style={{
        padding: paddingOfContainer[size],
        height: heightOfContainer[size],
      }}
    >
      <button
        className="select-route-active-call-midia__main-button"
        style={{
          width:
            numberOfRoutes <= 1 && size === "small"
              ? "24.5px"
              : sizeOfButton[size],
          padding: paddingOfButton[size],
          paddingRight: numberOfRoutes > 1 ? "0px" : paddingOfButton[size],
          borderRadius: numberOfRoutes > 1 ? "8px 0px 0px 8px" : "8px",
        }}
        onClick={(e) => {
          onChooseRoute(e, PermissionRouter);
          return;
        }}
      >
        {type === "icones" ? (
          <Tooltippy content={renderCorrectMidiaName[midiaId]} placement="top">
            {renderCorrectIcon[midiaId]}
          </Tooltippy>
        ) : (
          <li style={{ width: "100%" }}>{renderCorrecListElement[midiaId]}</li>
        )}
        {Boolean(numberOfRoutes) && (
          <span
            className={`select-route-active-call-midia__main-button__number-of-routes ${
              type === "list" ? "list-type-of-number-of-routes" : ""
            }`}
            style={{ fontSize: sizeOfNumberRoutes[size], zIndex: 1 }}
          >
            {numberOfRoutes}
          </span>
        )}
      </button>
      {/* {Boolean(numberOfRoutes) && numberOfRoutes !== 1 && (
        <div className="select-route-active-call-midia__drop-down-container">
          <OptionsDropDown
            onChoose={onChooseRoute}
            routesGroup={routeOptions}
            midiaId={midiaId}
            type={type}
            PermissionRouter={PermissionRouter}
          >
            <ArrowDown2 size="12" color="#455cc7" />
          </OptionsDropDown>
        </div>
      )} */}
      {numberOfRoutes > 1 && (
        <div
          className="select-route-active-call-midia__drop-down-container"
          style={{ height: "100%" }}
        >
          <OptionsDropDown
            onChoose={onChooseRoute}
            routesGroup={routeOptions}
            midiaId={midiaId}
            type={type}
            PermissionRouter={PermissionRouter}
            open={open}
            setOpen={setOpen}
            size={size}
          >
            <div
              style={{
                width: "100%",
                height: "16.8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <ArrowDown2 size={sizeOfSvg[size]} color="#455cc7" />
            </div>
          </OptionsDropDown>
        </div>
      )}
    </div>
  );
};

export default SelectRouteActiveCall;
